var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RightMenu"},[_c('div',{staticClass:"menu menu-wechat-container"},[_c('div',{staticClass:"wechat-preview"},[_c('img',{attrs:{"src":`${_vm.$CdnServerAddress}websit/web/wxcode.png`}})]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wechat-title"},[_c('div',[_vm._v("观看更多")]),_c('div',[_vm._v("视频案例")])])
}]

export { render, staticRenderFns }